export interface IStep {
  headerTitle?: string;
  title: string;
  description?: string;
  component: string;
}

export const stepNames: Record<string, string> = Object.freeze({
  INFO: 'info',
  COMPLIMENTS: 'compliments',
  WORDS: 'words',
  THANKS: 'thanks',
});

export const flow: Array<string> = [stepNames.INFO, stepNames.COMPLIMENTS, stepNames.WORDS, stepNames.THANKS];

export const steps = (firstname: string): { [key: string]: IStep } => {
  return {
    [stepNames.INFO]: {
      headerTitle: 'Your info',
      title: `Welcome, <br> please tell us who you are`,
      description: `You are endorsing ${firstname}`,
      component: 'PublicPortfolioTestifyInfo',
    },
    [stepNames.COMPLIMENTS]: {
      headerTitle: `Describe ${firstname}`,
      title: `What makes ${firstname} stand out?`,
      description: 'Select 1-3 compliments',
      component: 'PublicPortfolioTestifyCompliments',
    },
    [stepNames.WORDS]: {
      headerTitle: 'Few words',
      title: `${firstname} would appreciate a few words`,
      component: 'PublicPortfolioTestifyWords',
    },
    [stepNames.THANKS]: {
      title: 'Thank you',
      description: `You just made ${firstname}’s day!`,
      component: '',
    },
  };
};

export const REVIEW_ROUTE_NAME = 'review-step';

export const OTHER = 'other';
export const skills: Array<string> = [
  'analytical',
  'problem-solver',
  'consultative',
  'direct',
  'diligent',
  'honest',
  'empathetic',
  'responsive',
  'friendly',
  OTHER,
];

export const ANALYTICS_STEPS_NAMES = {
  [stepNames.INFO]: 'personal-info',
  [stepNames.COMPLIMENTS]: 'compliments',
  [stepNames.WORDS]: 'written-testimonial',
  [stepNames.THANKS]: 'finish',
};
